import React from 'react';
import NewsletterUnsubscribeContainer from './NewsletterUnsubscribeContainer';
import NewsletterUnsubscribeConnectorApollo from './Connector/Apollo/Unsubscribe/NewsletterUnsubscribeConnectorApollo';

class NewsletterUnsubscribePage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <NewsletterUnsubscribeConnectorApollo>
                {({ ...unsubscribe }) => (
                    <NewsletterUnsubscribeContainer {...unsubscribe} />
                )}
            </NewsletterUnsubscribeConnectorApollo>
        );
    }
}

export default NewsletterUnsubscribePage;
